import { Link } from "react-router-dom";
import type { Special } from "@/types";

interface SpecialCardProps {
  special: Special;
  className?: string;
}

export default function SpecialCard({ special, className = "" }: SpecialCardProps) {
  return (
    <Link
      to={`/specials?focus=${special.id}`}
      className={`group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200">
        <img
          src={special.cover}
          alt={`${special.title} 专题封面`}
          title={`${special.title} - 555电影片单`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-3 py-1 text-xs font-semibold text-background-50">
          热门片单
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="line-clamp-1 font-heading text-base font-semibold text-foreground-950 md:text-lg">
          {special.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-primary-600 md:text-sm">{special.subtitle}</p>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {special.description}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
          查看片单
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}